export default "__VITE_ASSET__1c8267f1__"